import { MediaGalleryTimelineData } from '../MediaGalleryTimeline';

export const isTimelineItemActive = (
  item: MediaGalleryTimelineData,
  currentSlideIndex: number,
): boolean => {
  return currentSlideIndex >= item.indexFrom && currentSlideIndex <= item.indexTo;
};
